export default (axios, path = '/data') => ({
  findAllByTeamId: async (teamId) => {
    return await axios.get(`${path}/team/${teamId}`)
  },
  findAllDataBought: async (gameId) => {
    return await axios.get(`${path}/game/${gameId}`)
  },
  download: async (id) => {
    return await axios.get(`${path}/${id}`, {
      responseType: 'blob',
    })
  },
  purchase: async (type) => {
    return await axios.post(`${path}/${type}`,)
  },
})
